<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="add-card" @click="toBindCard()">
        <van-icon name="plus" />
        <span>{{ $t('setting.add_bank') }}</span>
      </div>
      <div class="bank">
        <div class="info" v-for="(item, index) in bankInfo" :key="index">
          <div class="del-btn">
            <van-icon name="close" @click="delItem(item)" size="24" color="red" />
          </div>
          <div class="row-content">
            {{ $t('setting.band_name') }}
            <div class="text van-multi-ellipsis--l2">{{ item.bankinfo }}</div>
          </div>
          <div class="row-content">
            {{ $t('setting.username') }}
            <div class="text van-multi-ellipsis--l2">{{ item.username }}</div>
          </div>
          <div class="row-content">
            {{ $t('setting.band_account') }}
            <div class="text van-multi-ellipsis--l2">{{ item.bankid }}</div>
          </div>
          <div class="row-content">
            {{ $t('setting.bankname') }}
            <div class="text van-multi-ellipsis--l2">
              {{ item.branch_name }}
            </div>
          </div>
          <div class="row-content">
            {{ $t('setting.bnakcode') }}
            <div class="text van-multi-ellipsis--l2">
              {{ item.branch_code }}
            </div>
          </div>
        </div>
      </div>
      <div class="tips" style="display: none">
        {{ $t('setting.bind_bank_tip') }}
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  data () {
    return {
      is_bind: false,
      bankInfo: [],
      userInfo: {}
    }
  },
  methods: {
    back () {
      return window.history.back()
    },
    getUserBankInfo () {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          this.bankInfo = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo () {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          this.name = res.data.name
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    toBindCard () {
      if (!this.userInfo.name) {
        this.$router.push('Setname')
        this.$toast(this.$t('setting.set_name_bank'))
        return true
      } else if (!this.userInfo.paypassword) {
        this.$router.push('SetPayPassword')
        this.$toast(this.$t('setting.set_pwd_bank'))
        return true
      } else {
        this.$router.push({ path: '/BindCard' })
      }
    },
    delItem (item) {
      Dialog.confirm({
        title: '溫馨提示',
        message: '是否刪除此記錄'
      })
        .then(() => {
          this.$http({
            method: 'post',
            url: 'del_bank',
            data: { id: item.id }
          }).then(res => {
            this.$toast(res.msg)
            if (res.code === 200) {
              this.getUserBankInfo()
            }
          })
        })
        .catch(() => {})
    }
  },
  created () {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';
.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.manage-card .wrapper {
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.wrapper .add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  height: 90px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
}
.wrapper .add-card span {
  margin-left: 10px;
  font-size: 30px;
}
.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}

.wrapper .bank {
  height: calc(100vh - 190px);
  overflow-y: auto;
}

.wrapper .bank .info {
  margin: 20px;
  flex: 1;
  padding: 10px 20px;
  background: #fff;
  color: #000;
  border-radius: 20px;
  position: relative;
}
.wrapper .bank .info .row-content {
  margin: 10px 0;
  font-size: 30px;
  font-weight: 600;
}

.wrapper .bank .info .row-content div.text {
  font-weight: normal;
}
.wrapper .bank .info div.del-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
